import { HTMLAttributes } from 'react'
import Link from 'next/link'

import Image from '@/components/base/Image'
import Typography, { TypographyProps } from '@/components/base/Typography'

import { cn } from '@/lib/utils'
import { WPImage, WPLink } from '@/types'

export type ImageCardProps = HTMLAttributes<HTMLDivElement> &
  Partial<{
    image: WPImage
    color: string
    overline: string
    title_variant: TypographyProps['variant']
    title_component: TypographyProps['component']
    title: string
    link: WPLink
  }>

const ImageCard = ({
  image,
  color,
  link,
  overline,
  title,
  title_variant,
  // title_component,
  className,
  ...props
}: ImageCardProps) => {
  return (
    <div
      className={cn([
        'relative h-full w-full rounded-[3rem] bg-mainbody',
        className
      ])}
      style={{ backgroundColor: color }}
      {...props}
    >
      {image && image.url ? (
        <div
          className={cn([
            'absolute left-0 top-0 h-full w-full overflow-hidden rounded-[3rem]',
            'after:absolute after:left-0 after:top-0 after:h-full after:w-full after:rounded-[3rem] after:bg-black/50'
          ])}
        >
          <Image source={image} fill fit="cover" className="rounded-[3rem]" />
        </div>
      ) : null}

      <div
        className={cn([
          'relative flex h-full w-full flex-col p-[2rem]',
          'space-y-[3rem] md:space-y-[10rem] lg:space-y-[8rem] xl:space-y-[16rem]'
        ])}
      >
        {title ? (
          <div className="flex shrink-0 grow">
            <Typography variant="body" className="text-white">
              {overline}
            </Typography>
          </div>
        ) : null}

        {title ? (
          <div className="flex shrink-0">
            <Link
              href={link?.url || '/'}
              target={link?.target}
              className="after:absolute after:left-0 after:top-0 after:h-full after:w-full"
            >
              <Typography
                variant={title_variant}
                // component={title_component}
                className="text-white"
              >
                {title}
              </Typography>
            </Link>
          </div>
        ) : null}
      </div>
    </div>
  )
}

export default ImageCard
